import { omit } from "lodash-es";
import { useMemo } from "react";
import { notEmpty } from "../../../../../../../utils/not-empty";

import type { MomentRecipientsClassify } from "../../../../../hooks/use-moment-recipients-classify";
import type { PreviewDataRecipient } from "../../../../../server/supabase-preview-service";
import type { PreviewSubject } from "./use-selected-preview-info";

export function useParsedRecipients(
  data: PreviewDataRecipient[] | null,
  classifyData: MomentRecipientsClassify | null,
): PreviewSubject[] {
  return useMemo(() => {
    if (!data) return [];

    if (classifyData?.type === "connection") {
      return data
        .map(
          ({
            connection_display,
            connection_first_name,
            connection_email,
            connection_id,
            connection_last_name,
            ...recipient
          }) => {
            if (!connection_id) return null;
            return {
              ...recipient,
              connection: {
                id: connection_id,
                first_name: connection_first_name ?? "",
                last_name: connection_last_name ?? "",
                email: connection_email ?? "",
                display: connection_display ?? "",
              },
            };
          },
        )
        .filter(notEmpty);
    }

    return data.map((recipient) =>
      omit(
        recipient,
        "connection_id",
        "connection_first_name",
        "connection_last_name",
        "connection_email",
        "connection_display",
      ),
    );
  }, [data, classifyData]);
}
